/**
 * The CMSBlock component
 */
import React from "react";
import ContentBlockFullWidth from '../ContentBlockFullWidth';
import ContentBlockShowMore from '../ContentBlockShowMore';

/**
 * Stateless react component to render the CMSBlock page
 * @param {Object} props the props passed to the page.
 */
const CMSBlock = (props) => {
  const {cmsblock} = props;
  if(cmsblock.expandable){
    return <ContentBlockShowMore {...props} />
  } else {
    return <ContentBlockFullWidth {...props} />
  }
}
export default CMSBlock;
